type Account = { id: string };

export default class ThirdPartyAccounts {
  declare accounts: Account[];

  constructor({ elements }: { elements: Account[] }) {
    this.accounts = elements;
  }

  /**
   * Creates a map of linked account types.
   * Note: 'facebookLimited' accounts are mapped to 'facebook' for compatibility
   * with account deletion and other flows that only check for 'facebook' type.
   *
   * @returns A map where keys are account types and values are true for linked accounts
   */
  getLinkedAccountMap() {
    const map: { [key: string]: boolean } = {};
    this.accounts.forEach(({ id }) => {
      if (id === 'facebookLimited') {
        map.facebook = true;
      } else {
        map[id] = true;
      }
    });
    return map;
  }
}
